module.exports = __webpack_public_path__ + "static/mills-logo-7fb16049a598d55ccf759d1bb66bd2aa.svg";